import "./WebsiteDesign.module.css";
import Header from "@/reusable_sections/Header";
import WebsiteDesignHero from "./sections/WebsiteDesignHero";
import WebsiteDesignServices from "./sections/WebsiteDesignServices";
import WhyChooseOurWebsiteDesign from "./sections/WhyChooseOurWebsiteDesign";
import WebsiteDesignFaq from "./sections/WebsiteDesignFaq";
import ReadyToStartYourProject from "./sections/ReadyToStartYourProject";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
import AgencyFeatures from "./sections/AgencyFeatures";
import Pricing from "./sections/Pricing";
export default function WebsiteDesignPage() {
  return <div>
      <Header />
      <WebsiteDesignHero />
      <WebsiteDesignServices />
      <AgencyFeatures />
      <WhyChooseOurWebsiteDesign />
      <Pricing />
      <WebsiteDesignFaq />
      <ReadyToStartYourProject />
      <ContactUs />
      <Footer />
    </div>;
}